import React, { useEffect } from "react";

import useState from "react-usestateref";
import Pagination from "@material-ui/lab/Pagination";
import { Typography, Button, CircularProgress } from "@material-ui/core";
import useStyles from "../components/Header/styles";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";

import { postMethod } from "../core/service/common.api";
import moment from "moment";
import * as Icons from "@material-ui/icons";
import SearchBar from "./searchbar";
import Skeleton from "react-skeleton-loader";
import FromDatePicker from "./fromdatepicker";
import ToDatePicker from "./todatepicker";
function Coursecontact() {
  const [currentPage, setCurrentPage] = useState(1);
  const [coursecontactlist, Setcoursecontactlist, Setcoursecontactlistref] =
    useState([]);
  const [totalPage, setTotalpages] = useState(0);
  const [activefilter, setActivefilter] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [toDate, setToDate] = useState("");
  var classes = useStyles();
  const recordPerPage = 10;
  const totalRecords = 15;
  const pageRange = 5;
  const handlePageChange = (pageNumber) => {
    getcoursecotactlist(pageNumber);
    setCurrentPage(pageNumber);
  };

  const [pageloader, setpageloader] = useState(true);

  useEffect(() => {
    getcoursecotactlist();
  }, []);

  const getcoursecotactlist = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search: search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.getcoursecotactlist,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        Setcoursecontactlist(resp.data.data);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {}
  };

  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getcoursecotactlist(1);
  };

  return (
    <>
      <div>
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
          <Typography
            fullWidth
            color="inherit"
            className={classes.blog_categories}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Course Contact list
          </Typography>

          <div className="right_top">
            <SearchBar
              placeholder="Search by Name"
              className="mb-3"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
            />

            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>
          </div>
        </div>
        <div className="table_outer">
          <div className="table-responsive">
            <table class="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th> S.No</th>
                  <th> Name </th>
                  <th> Email</th>
                  <th> Mobile Number</th>
                  <th> Date</th>
                </tr>
              </thead>
              <tbody className="admin_tbody">
                {pageloader === true ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : Setcoursecontactlistref.current.length > 0 ? (
                  Setcoursecontactlistref.current &&
                  Setcoursecontactlistref.current.map((list, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{list.name}</td>
                        <td>{list.email}</td>
                        <td>{list.mobileNumber}</td>
                        <td>{moment(list.createdAt).format("lll")}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="no-record">
                    <td colSpan={9}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* <Pagination
        itemClass="page-item" // add it for bootstrap 4
        linkClass="page-link" // add it for bootstrap 4
        ctivePage={currentPage}
        itemsCountPerPage={recordPerPage}
        totalItemsCount={totalPage}
        pageRangeDisplayed={pageRange}
        onChange={handlePageChange}
      /> */}
        {totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        )}
      </div>
    </>
  );
}

export default Coursecontact;
